import moment from 'moment-timezone';

const timezone = () => moment.tz(moment.tz.guess().toString()).format('z');

export default timezone;